import React from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth"; // Import the correct functions
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";

function ForgotPassword() {
    const auth = getAuth();
    const history = useNavigate();
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      const emailVal = e.target.email.value;
  
      sendPasswordResetEmail(auth, emailVal)
        .then(() => {
          alert("Check your email for password reset instructions.");
          history("/");
        })
        .catch((err) => {
          alert(err.message);
        });
    };

  return (
    <div className="forgot-password-container">
      <h1 className="page-title">Ceylon Eye Care Optometric Association</h1>
      <p className="page-description">
        Welcome to Ceylon Eye Care Optometric Association. 
        Established as the premier professional body for optometrists in Sri Lanka, we are 
        committed to advancing eye care standards and promoting visual health nationwide through advocacy, 
        professional development, and public awareness.
      </p>
      
      <div className="">
        <h2 className="form-title">Forgot Password</h2>
        <p className="forgot-password-paragraph">
          Please enter your email address below to receive password reset instructions.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            className="form-control"
            type="email"
            name="email"
            placeholder="Enter your email"
            required
          />
          <button className="btn-reset" type="submit">
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
